import { admin as arAdmin } from "./ar/admin";
import { analytics as arAnalytics } from "./ar/analytics";
import { approvals as arApprovals } from "./ar/approvals";
import { assistant as arAssistant } from "./ar/assistant";
import { auth as arAuth } from "./ar/auth";
import { automation as arAutomation } from "./ar/automation";
import { calendar as arCalendar } from "./ar/calendar";
import { common as arCommon } from "./ar/common";
import { contacts as arContacts } from "./ar/contacts";
import { copilot as arCopilot } from "./ar/copilot";
import { content as arContent } from "./ar/content";
import { dashboards as arDashboards } from "./ar/dashboards";
import { home as arHome } from "./ar/home";
import { inbox as arInbox } from "./ar/inbox";
import { jobs as arJobs } from "./ar/jobs";
import { legal as arLegal } from "./ar/legal";
import { oauth as arOauth } from "./ar/oauth";
import { moderation as arModeration } from "./ar/moderation";
import { onboarding as arOnboarding } from "./ar/onboarding";
import { quick as arQuick } from "./ar/quick";
import { settings as arSettings } from "./ar/settings";
import { shell as arShell } from "./ar/shell";
import { studio as arStudio } from "./ar/studio";
import { people360 as arPeople360 } from "./ar/people360";
import { plans as arPlans } from "./ar/plans";
import { mediaEditor as arMediaEditor } from "./ar/mediaEditor";
import { agents as arAgents } from "./ar/agents";
import { media as arMedia } from "./ar/media";
import { welcome as arWelcome } from "./ar/welcome";
import { access as arAccess } from "./ar/access";
import { adminConsole as arAdminConsole } from "./ar/admin-console";
import { aiOrg as arAiOrg } from "./ar/aiOrg";
import { people as arPeople } from "./ar/people";
import { kit as arKit } from "./ar/kit";
import { appShell as arAppShell } from "./ar/app-shell";
import { commentStatus as arCommentStatus } from "./ar/commentStatus";
import { admin } from "./en/admin";
import { analytics } from "./en/analytics";
import { approvals } from "./en/approvals";
import { assistant } from "./en/assistant";
import { auth } from "./en/auth";
import { automation } from "./en/automation";
import { calendar } from "./en/calendar";
import { common } from "./en/common";
import { contacts } from "./en/contacts";
import { copilot } from "./en/copilot";
import { content } from "./en/content";
import { dashboards } from "./en/dashboards";
import { home } from "./en/home";
import { inbox } from "./en/inbox";
import { jobs } from "./en/jobs";
import { legal } from "./en/legal";
import { oauth } from "./en/oauth";
import { moderation } from "./en/moderation";
import { onboarding } from "./en/onboarding";
import { quick } from "./en/quick";
import { settings } from "./en/settings";
import { shell } from "./en/shell";
import { studio } from "./en/studio";
import { people360 } from "./en/people360";
import { plans } from "./en/plans";
import { mediaEditor } from "./en/mediaEditor";
import { agents } from "./en/agents";
import { aiOrg } from "./en/aiOrg";
import { people } from "./en/people";
import { media } from "./en/media";
import { welcome } from "./en/welcome";
import { access } from "./en/access";
import { adminConsole } from "./en/admin-console";
import { kit } from "./en/kit";
import { appShell } from "./en/app-shell";
import { commentStatus } from "./en/commentStatus";
import type { Messages } from "./types";

/** One namespace per feature, so each screen owns its strings. */
export const en = { common, shell, auth, onboarding, home, inbox, approvals, content, automation, analytics, studio, assistant, contacts, settings, dashboards, jobs, moderation, admin, quick, calendar, copilot, oauth, legal, people360, plans, mediaEditor, media, people, welcome, access, adminConsole, aiOrg, agents, kit, appShell, commentStatus };

export const ar: Messages<typeof en> = {
  common: arCommon,
  shell: arShell,
  auth: arAuth,
  onboarding: arOnboarding,
  home: arHome,
  inbox: arInbox,
  approvals: arApprovals,
  content: arContent,
  automation: arAutomation,
  analytics: arAnalytics,
  studio: arStudio,
  assistant: arAssistant,
  contacts: arContacts,
  settings: arSettings,
  dashboards: arDashboards,
  jobs: arJobs,
  moderation: arModeration,
  admin: arAdmin,
  copilot: arCopilot,
  quick: arQuick,
  calendar: arCalendar,
  oauth: arOauth,
  legal: arLegal,
  people360: arPeople360,
  plans: arPlans,
  mediaEditor: arMediaEditor,
  agents: arAgents,
  media: arMedia,
  welcome: arWelcome,
  access: arAccess,
  adminConsole: arAdminConsole,
  aiOrg: arAiOrg,
  people: arPeople,
  kit: arKit,
  appShell: arAppShell,
  commentStatus: arCommentStatus,
};
